var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcedureConfirmed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_3287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.82837 13.5415C9.82837 15.588 11.4953 17.2549 13.5417 17.2549C15.5882 17.2549 17.2551 15.588 17.2551 13.5415C17.2551 11.495 15.5882 9.82812 13.5417 9.82812C11.4953 9.82812 9.82837 11.495 9.82837 13.5415ZM15.4809 13.0051L13.1292 15.3652L11.6026 13.8303L12.1802 13.2527L13.1292 14.1934L14.9033 12.4275L15.4809 13.0051Z",
    fill: "#41A041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5417 20.5833C17.4118 20.5833 20.5833 17.4118 20.5833 13.5417H18.9329C18.9329 16.4959 16.4959 18.9054 13.5417 18.9054C10.5874 18.9054 8.1779 16.4959 8.1779 13.5417C8.1779 10.5874 10.5874 8.1779 13.5417 8.1779C14.7465 8.1779 15.8605 8.57396 16.7517 9.25065L16.1245 9.8778L19.0374 10.4554L18.4599 7.54247L17.9317 8.07059C16.7269 7.10514 15.2003 6.5 13.5417 6.5C9.6715 6.5 6.5 9.6715 6.5 13.5417C6.5 17.4118 9.6715 20.5833 13.5417 20.5833Z",
    fill: "#41A041"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_3287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.0833,
    height: 14.0833,
    fill: "white",
    transform: "translate(6.5 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcedureConfirmed);
export default __webpack_public_path__ + "static/media/Procedure Confirmed.e5ef547443512f02ecd8b199bbbd1c11.svg";
export { ForwardRef as ReactComponent };